import { ScheduleAPI } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaScheduleV2Service = bindHTTP(ScheduleAPI);
export const serviceName = 'schedule-v2' as const;
